import Component from '../abstracts/Component';
import 'bootstrap'; //TODO: import single component

 
export default class CollapseComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-collapse]'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  importCollpase() {

    let elements = document.querySelectorAll(this.SELECTORS.main);

    elements.forEach(el => {
      $(el).collapse();
    });
  }
     
    

  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importCollpase()
  }
}
